import { PACKAGES_PURCHASED } from "../constants/types";

export default function (state = [], action) {
    switch (action.type) {
      case PACKAGES_PURCHASED:
        return action.payload;
      default:
        return state;
    }
  }